import React from 'react';
import components from '../../components';
import reportUtils from '../../utils/report';

const { CustomDropdown } = components;

const GenerateReportButton = () => {
  const onReportOptionSelected = reportOption => {
    if (reportOption === 'pdf') {
      window.print();
    }
  };

  return (
    <div className="report-dropdown">
      <CustomDropdown
        staticTitle={'Generate Report'}
        items={reportUtils.reportTypes.filter(type => type.id === 'pdf')} //TODO: enable all report types when ready
        valueField={'id'}
        displayField={'name'}
        direction="end"
        handleSelection={e => onReportOptionSelected(e.target.value)}
        outline={false}
      />
      {/* <CustomReport
        classes={'custom-report'}
        customProject={project}
        report={{
          ...customReport,
          cmsId: selectedTemplate?.cmsId,
          solutions: getReportSolution(selectedTemplate?.compatibleDatasources)
        }}
        onSubmit={onCustomReportChange}
        onClose={() => toggleReportModal('custom')}
        isOpen={modals.isCustomReportOpen}
        customFrequencies={[{ value: 'single', label: 'Single' }]}
      />
      <QuickReport
        classes={'quick-report'}
        project={project}
        report={customReport}
        onClose={() => {
          setCustomReport(report);
          toggleReportModal('quick');
        }}
        isOpen={modals.isQuickReportOpen}
        selectedTemplate={selectedTemplate}
      /> */}
    </div>
  );
};

export default GenerateReportButton;
